import { gql } from "graphql-tag"

import { DEFAULTS } from "@/graphql/schemas/shared/utils/defaults"

const typeTourPlanning = gql`
   
    type TourPlanning {
      admNumber: String
      id: ID 
      tourNumber: String
      interval: Int
      isTourAgreed: Boolean
      customer: Customer
      total: Int
      latest: String
    }

    type TourPlannings {
      total: Int
      items: [TourPlanning]
    }

    type AgreedTour{
      id: ID
      customerNumber: String
      calendarWeek: Int
      admNumber: String
      creationAt: String
      creationBy: String
    }

    type Query {
      admWeekTours(
        week: Int
        offset: Int = ${DEFAULTS.QUERY.OFFSET}
        limit: Int = ${DEFAULTS.QUERY.LIMIT}
        sort: Sort
        sortWithinLimits: Boolean = false
        lang: String = ""
        cdn: Boolean = true
      ): TourPlannings

      admTours(
        admUserId: ID
        offset: Int = ${DEFAULTS.QUERY.OFFSET}
        limit: Int = ${DEFAULTS.QUERY.LIMIT}
        sort: Sort
      ): TourPlannings
    }
    type Mutation {
      updateAgreedTour(
        isTourAgreed: Boolean!
        customerId: ID!
        calendarWeek: Int!
        lang: String = ""
      ): AgreedTour
    }
`

export { typeTourPlanning }

export default typeTourPlanning
